<template src="./Index.html"></template>

<script>
export default {
  components: {},
  created() {
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
  },
  computed: {
    administrationTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AdministrationTypes
      );
    },
    administrations() {
      return [
        ...this.$store.state.lookups.administrations,
      ];
    },
    departments() {
      return this.$store.state.lookups.departments;
    },
    units() {
      return this.$store.state.lookups.units;
    },
    pageCount() {
      return Math.ceil(
        this.totalItems /
        this.filters.pageSize
      );
    },

  },
  data() {
    return {

      subtitle: "",
      items: [
        {
          text: "التقارير",
        },
        {
          text: "تقرير اجازات التقاعد",
        },
      ],
      itemId: 0,
      view: 0,
      data: [],
      totalItems: 0,
      filters: {
        page: 1,
        pageSize: 10,
        administrationTypeId: null,
        administrationId: null,
        departmentId: null,
        unitId: null,
        employeeNo: null,
        nationalNo: null,
      },
      headers: [
        {
          text: "الرقم التسلسلي ",
          value: "employeeNo",
          sortable: false,
          align: "start",
        },
        {
          text: "اسم الموظف",
          value: "fullName",
          sortable: false,
          align: "start",
        }, {
          text: "الرقم الوطني",
          value: "nationalNo",
          sortable: false,
          align: "start",
        }, {
          text: "الجنس",
          value: "gender",
          sortable: false,
          align: "start",
        }, {
          text: "العمر",
          value: "age",
          sortable: false,
          align: "start",
        },
        {
          text: "رصيد الاجازات",
          value: "remindedDuration",
          sortable: false,
          align: "start",
        },
        // { text: "تاريخ الحصول عليها", value: "jobGradeDate", sortable: false },     
        // { text: "تاريخ الحصول عليه", value: "correlatorDate", sortable: false },     
        
        // { text: "تاريخ الميلاد", value: "dateOfBirth", sortable: false },
        { text: "تاريخ  التقاعد ", value: "remaining", sortable: false,align: "center", },
        
        { text: "الدرجة الوظيفية ", value: "jobGradeName", sortable: false },     
      { text: "المربوط ", value: "currentCorrelatorId", sortable: false },     
        {
          text: "الادارة / الفرع",
          value: "administrationName",
          sortable: false,
          align: "start",
        },
        {
          text: "القسم ",
          value: "departmentName",
          sortable: false,
          align: "start",
        },       
          {
          text: "الوحدة ",
          value: "unitName",
          sortable: false,
          align: "start",
        },       {
          text: "المجموعة الوظيفية ",
          value: "jobGroupName",
          sortable: false,
          align: "start",
        },      
        // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        // { text: "تاريخ التسجيل", value: "createdOn", sortable: false },     
      ],
    };
  },
  methods: {
    remainingAmout(value) {
      const date1 = new Date();
      const date2 = new Date(value);
console.log(date1);
console.log(date2);
      const differenceInDays = Math.floor(date2.getTime() - date1.getTime() / (1000 * 60 * 60 * 24));
      return differenceInDays;
    },
    changeAdministration() {
      this.filters.departmentId = null;
      this.filters.unitId = null;
      if (this.filters.administrationTypeId != 1002) {
        this.$store.dispatch(
          "lookups/getDepartments",
          this.filters.administrationId
        );
      } else {
        this.$store.dispatch("lookups/getUnitsById", {
          typeId: 1,
          id: this.filters.administrationId,
        });
      }
      this.getAll();
    },
    changeDepartment() {
      this.filters.unitId = null;
      this.$store.dispatch("lookups/getUnitsById", {
        typeId: 2,
        id: this.filters.departmentId,
      });
      this.getAll();
    },
    changeType() {
      this.filters.administrationId = null;
      this.filters.departmentId = null;
      this.filters.unitId = null;
      this.$store.dispatch(
        "lookups/getAdministrationsByType",
        this.filters.administrationTypeId
      );
      this.getAll();
    },
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("reports/getRetirement", this.filters).then((res) => {
        this.data = res.data;
        this.totalItems = res.totalItems;
      });
    },
    download() {
      let filters = {
        administrationTypeId: this.filters.administrationTypeId,
        administrationId: this.filters.administrationId,
        departmentId: this.filters.departmentId,
        unitId: this.filters.unitId,
        employeeNo: this.filters.employeeNo,
        nationalNo: this.filters.nationalNo,
      };
      const paramsString = Object.entries(filters)
        .filter(([, val]) => val !== null)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      window.open(`/api/reports/RetirementExcel?${paramsString}`, "_blank");
    },

  },
};
</script>
